module.exports = __webpack_public_path__ + "static/media/ClickButton.2bb51bdc.wav";